<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
     style="background: #f6f9fa;"
     (keydown.enter)="submit($event)">
  <div>
    <div class="auth-box">
      <div class="logo">
        <span class="db">
          <img src="assets/images/logo-dark-blue.svg" alt="logo" style="max-height: 200px; max-width:100%;" />
        </span>
        <h5 class="font-medium m-b-20">{{ 'passwordReset.title' | translate }}</h5>
        <span>{{ 'passwordReset.description' | translate }}</span>
      </div>

      <div *ngIf="message" class="alert" [ngClass]="{'alert-success': messageType === 'success', 'alert-danger': messageType === 'error'}">
        {{ message }}
      </div>

      <form *ngIf="hasToken" class="form-horizontal m-t-20" (submit)="submit($event)">
        <div class="input-group mb-3">
          <div class="input-group-text"><i class="ti-pencil"></i></div>
          <input
            type="password"
            class="form-control form-control-lg"
            [(ngModel)]="password"
            name="password"
            autocomplete="new-password"
            [placeholder]="'passwordReset.passwordPlaceholder' | translate"
            [attr.aria-label]="'passwordReset.passwordPlaceholder' | translate"
            [disabled]="isLoading">
        </div>

        <div class="input-group mb-3">
          <div class="input-group-text"><i class="ti-pencil"></i></div>
          <input
            type="password"
            class="form-control form-control-lg"
            [(ngModel)]="confirmPassword"
            name="confirmPassword"
            autocomplete="new-password"
            [placeholder]="'passwordReset.confirmPasswordPlaceholder' | translate"
            [attr.aria-label]="'passwordReset.confirmPasswordPlaceholder' | translate"
            [disabled]="isLoading">
        </div>

        <div class="form-group text-center">
          <div class="col-xs-12 p-b-20">
            <button class="btn btn-block btn-lg btn-info" type="submit" [disabled]="isLoading">
              {{ isLoading ? ('passwordReset.submitting' | translate) : ('passwordReset.submit' | translate) }}
            </button>
          </div>
          <div class="col-xs-12">
            <a href="#" (click)="goToLogin($event)">{{ 'passwordReset.backToLogin' | translate }}</a>
          </div>
        </div>
      </form>

      <div *ngIf="!hasToken" class="form-group text-center m-t-20">
        <a href="#" (click)="goToLogin($event)">{{ 'passwordReset.backToLogin' | translate }}</a>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <app-custom-footer></app-custom-footer>
</footer>
